export default __webpack_public_path__ + "static/portfolio_gallery_17-8d39f9d1febbd16cedf173011c0de7d1.jpg";